// extracted by mini-css-extract-plugin
export default {"sidebar-move":"SidebarMove_sidebar-move__l-zbY","sidebar-icon":"SidebarMove_sidebar-icon__FF4ws","move":"SidebarMove_move__q+EFj","sidebar-img":"SidebarMove_sidebar-img__fwWJ3"};